import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {URLS} from '../../environments/environment';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CalculatorService {

  constructor(private http: HttpClient) {
  }

  getCurrencies(): Observable<any> {
    return this.http.get(URLS.API + 'currency/getLatest');
  }

  uploadFile(file: File, type: string) {
    let formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('type', type);
    return this.http.post(URLS.API + 'files/upload', formData);
  }

  getCalculatorSettings() {
    return this.http.get(URLS.API + 'calculator/settings');
  }

  handleCalculatorLoad() {
    return this.http.post(URLS.API + 'calculator/handleCalcLoad', {}, {withCredentials: true});
  }

  getPdf(order: any) {
    let headers: HttpHeaders = new HttpHeaders({'Accept': 'application/pdf'});
    return this.http.post(URLS.API + 'orders/new', {order}, {withCredentials: true});
  }

  getOrder(orderID: string) {
    return this.http.get(URLS.API + 'orders/get', {params: {id: orderID}, withCredentials: true});
  }
}
